import script from "./ViewTalk.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTalk.vue?vue&type=script&setup=true&lang=js"

import "./ViewTalk.vue?vue&type=style&index=0&id=34b848bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b848bc"]])

export default __exports__